import { useRef, type HTMLAttributes, type ReactNode } from 'react';

import {
  parentSvgStyle,
  responsiveLabelContainer,
} from './GaugeResponsiveLabel.sty.js';
import { Flex } from '../../../../layouts/flex/Flex.js';
import { useFontSizeForContainer } from '../../../core/hooks/useFontSizeForContainer.js';
import { useObserveContainerSize } from '../../../core/hooks/useObserveContainerSize.js';
import {
  DEFAULT_MAX_VALUE_FONT_SIZE,
  FONT_HEIGHT_RATIO,
} from '../../constants.js';

interface GaugeResponsiveLabelProps
  extends HTMLAttributes<HTMLParagraphElement> {
  text: string;
  prefixIcon?: ReactNode;
}

export const GaugeResponsiveLabel = (props: GaugeResponsiveLabelProps) => {
  const { text, prefixIcon, ...paragraphProps } = props;

  const labelRef = useRef<HTMLParagraphElement>(null);

  const [{ width, height }, observerRef] = useObserveContainerSize();

  let preferredFontSize = useFontSizeForContainer({
    container: { width: width, height: height * FONT_HEIGHT_RATIO },
    text: prefixIcon ? `00${text}` : `${text}`,
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    element: labelRef.current!,
  });

  if (preferredFontSize > DEFAULT_MAX_VALUE_FONT_SIZE) {
    preferredFontSize = DEFAULT_MAX_VALUE_FONT_SIZE;
  }
  const fontSize = `${Math.floor(preferredFontSize)}px`;

  return (
    <Flex className={responsiveLabelContainer} ref={observerRef}>
      <span
        ref={labelRef}
        className={parentSvgStyle}
        style={{ fontSize, lineHeight: fontSize }}
        {...paragraphProps}
      >
        {prefixIcon}
        {text}
      </span>
    </Flex>
  );
};
